/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import Filtro from './filtro';
import './filtros.css';

class Filtros extends React.Component {
  state = {
    filteredItems: [],
    filters: [],
    optionsActive: [],
  }

  componentDidMount = () => {
    const { items } = this.props;
    this.createFilters(items);
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.state.filteredItems !== prevState.filteredItems) {
      // this.createFilters(this.state.filteredItems);
    }
  }

  createFilters = (items) => {
    const generatedFilters = {};
    const { filters, updateListItems } = this.props;
    items.forEach((item) => {
      filters.forEach((filter) => {
        const { labelKey, label, getData } = filter;
        const value = getData(item);
        const filterObj = generatedFilters[labelKey];
        if (value && value !== '' && value !== ' ') {
          if (filterObj) {
            if (filterObj.options.filter((options) => options.value === value).length === 0) {
              generatedFilters[labelKey].options = [
                ...filterObj.options.concat({ value, active: false, labelKey }),
              ];
            }
          } else {
            generatedFilters[labelKey] = {
              label,
              getData,
              options: [
                { value, active: false, labelKey },
              ],
            };
          }
        }
      });
    });
    updateListItems(items);
    this.setState({
      filters: generatedFilters,
      filteredItems: items,
    });
  }

  filterItems = () => {
    const { items } = this.props;
    const { filters } = this.state;
    let optionsActive = [];
    let itemsFiltered = [];

    Object.keys(filters).forEach((filterKey) => {
      let localFiltered = [];
      let save = false;
      const { options, getData, label } = filters[filterKey];
      options.forEach((option) => {
        if (option.active) {
          if (!optionsActive.find((optionA) => optionA === option)) {
            optionsActive = [...optionsActive.concat(option)];
            save = true;
          }

          if (itemsFiltered.length === 0) {
            items.forEach((item) => {
              const itemValue = getData(item);
              if (itemValue === option.value && !itemsFiltered.find((itemF) => itemF === item)) {
                localFiltered = [
                  ...localFiltered.concat(item),
                ];
              }
            });
          } else {
            itemsFiltered.forEach((item) => {
              const itemValue = getData(item);
              if (itemValue === option.value) {
                localFiltered = [
                  ...localFiltered.concat(item),
                ];
              }
            });
          }

        }
      });
      if (save) {
        itemsFiltered = [...localFiltered];
      }
    });

    return {
      filteredItems: optionsActive.length > 0 ? itemsFiltered : items,
      optionsActive,
    };
  }

  handleClickFilter = (filterKey, optionTriggered) => {
    const { updateListItems } = this.props;
    const { filters } = this.state;
    const indexOptionToChange = filters[filterKey].options.findIndex((option) => option.value === optionTriggered.value);

    const updatedFilter = { ...filters[filterKey] };

    updatedFilter.options[indexOptionToChange] = {
      ...updatedFilter.options[indexOptionToChange],
      active: !updatedFilter.options[indexOptionToChange].active,
    };

    const { filteredItems, optionsActive } = this.filterItems();
    updateListItems(filteredItems);
    this.setState({
      optionsActive,
      filteredItems,
      filters: {
        ...filters,
        [filterKey]: { ...updatedFilter },
      },
    });
  }

  render() {
    const { filters, optionsActive, filteredItems } = this.state;
    return (
      <>
        {optionsActive.map((option) => (
          <span
            key={option.value}
            className='option-tag'
            data-test={option.labelKey}
          >
            {option.value}
            {' '}
            <i aria-hidden='true' onClick={() => this.handleClickFilter(option.labelKey, option)} className='fa fa-times' />
          </span>
        ))}
        <div className='panel-filtros'>
          {Object.keys(filters).map((filterKey) => (
            <Filtro
              key={filterKey}
              label={filters[filterKey].label}
              dataFilter={filters[filterKey]}
              handleClick={
                (option) => this.handleClickFilter(filterKey, option)
              }
            />
          ))}
        </div>
      </>
    );
  }
}

export default Filtros;
